import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS, API_BASE_URL_DOCS } from "../../../../config/api";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../../components/private/pagination";

const Contrato = () => {

  const { token, authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [contratos, setContratos] = useState([]);
  const [loading, setLoading] = useState(true);

  // FILTROS
  const [filter, setFilter] = useState({
    searchQuery: "",
    estado: "",
    fechaInicio: "",
    fechaFin: "",
    entidad: ""
  });

  // PAGINACIÓN
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // =======================
  // MODAL INFO CONTRACTUAL
  // =======================
  const [showDocModal, setShowDocModal] = useState(false);
  const [selectedContrato, setSelectedContrato] = useState(null);

  const [docList, setDocList] = useState([]);
  const [docError, setDocError] = useState("");

  const [newDocType, setNewDocType] = useState("");
  const [newDocFile, setNewDocFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  // =======================
  // CARGAR DATOS
  // =======================
  useEffect(() => {

    if (!token) return;

    const loadContratos = async () => {
      setLoading(true);

      const res = await authFetch(ENDPOINTS.getContratoProyecto);

      if (res.success) setContratos(res.data);
      else setContratos([]);

      setLoading(false);
    };

    loadContratos();

  }, [token, authFetch]);

  // =======================
  // MANEJO FILTROS
  // =======================
  const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
    setCurrentPage(1);
  };

  // =======================
  // FORMATO FECHA
  // =======================
    const formatDate = (dateString) => {
    if (!dateString) return "---";

    const [year, month, day] = dateString.split("-");

    return `${day}/${month}/${year}`;
    };
  // =======================
  // FILTRO
  // =======================
  const handleSearch = () => {

    const query = filter.searchQuery.toLowerCase();

    return contratos.filter((item) => {

      const contrato = (item.num_contrato || "").toLowerCase();
      const entidad = (item.entidad || "").toLowerCase();

      const matchSearch =
        contrato.includes(query) ||
        entidad.includes(query);

      const matchEstado =
        !filter.state || Number(item.state) === Number(filter.state);

      const matchEntidad =
        !filter.entidad || item.id_entidad === Number(filter.entidad);

      const matchFechaInicio =
        !filter.fechaInicio || item.start_date >= filter.fechaInicio;

      const matchFechaFin =
        !filter.fechaFin || item.end_date <= filter.fechaFin;

      return (
        matchSearch &&
        matchEstado &&
        matchEntidad &&
        matchFechaInicio &&
        matchFechaFin
      );
    });
  };

  const filtered = handleSearch();

  // =======================
  // PAGINACIÓN
  // =======================
  const totalPages = Math.ceil(filtered.length / recordsPerPage);

  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;

  const currentRecords = filtered.slice(indexOfFirst, indexOfLast);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // =======================
  // VER PDF
  // =======================
  const handleViewPDF = (doc) => {
    if (!doc) return alert("No hay documento");

    window.open(`${API_BASE_URL_DOCS}${doc}`, "_blank");
  };

  const handleOpenModal = async (contrato) => {
    setSelectedContrato(contrato);
    setShowDocModal(true);
    setDocList([]);
    setDocError("");

    try {
      const url = `${ENDPOINTS.getDocInformation}?numero_contrato=${contrato.num_contrato}`;
      const res = await authFetch(url);

      if (res.success) {
        setDocList(res.documents || []);
      } else {
        setDocError("No se pudieron cargar documentos");
      }

    } catch (error) {
      console.error(error);
      setDocError("Error al cargar documentos");
    }
  };

  const handleCloseModal = () => {
    setShowDocModal(false);
    setSelectedContrato(null);
  };

  // SUBIR DOCUMENTOS INFORMACIÓN CONTRACTUAL
  const handleUploadDocument = async () => {

  if (!newDocType) return setDocError("Seleccione tipo de documento");
  if (!newDocFile) return setDocError("Seleccione archivo");

  setUploading(true);

  try {
    const formData = new FormData();
    formData.append("numero_contrato", selectedContrato.num_contrato);
    formData.append("tipo_documento", newDocType);
    formData.append("archivo", newDocFile);

    const res = await fetch(ENDPOINTS.createDocInformation, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    });

    const data = await res.json();

    if (data.success) {

      // 🔥 recargar documentos
      handleOpenModal(selectedContrato);

      setNewDocType("");
      setNewDocFile(null);

    } else {
      setDocError(data.message);
    }

  } catch (error) {
    console.error(error);
    setDocError("Error subiendo archivo");
  } finally {
    setUploading(false);
  }
};

// ELIMINAR DOCUMENTOS INFORMACIÓN CONTRACTUAL
const handleDeleteDocument = async (doc) => {

  const confirmDelete = window.confirm(`¿Eliminar ${doc.name}?`);
  if (!confirmDelete) return;

  try {
    const res = await authFetch(ENDPOINTS.deleteDocInformation, {
      method: "DELETE",
      body: JSON.stringify({
        numero_contrato: selectedContrato.num_contrato,
        filename: doc.name
      })
    });

    if (res.success) {
      handleOpenModal(selectedContrato); // 🔥 refresca lista
    } else {
      alert("No se pudo eliminar");
    }

  } catch (error) {
    console.error(error);
    alert("Error eliminando documento");
  }
};

  if (loading) return <p>Cargando contratos...</p>;

  return (
    <div className="container mt-4 p-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Lista de Contratos</h2>

        <button
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/mod_proyectos/contrato_proyectos/createContrato")}
        >
          <i className="bi bi-plus-lg me-1"></i> Crear Contrato
        </button>
      </div>

      {/* FILTROS */}
      <div className="row mb-3">

        <div className="col-md-4">
          <label>Buscar por entidad</label>
          <input
            type="text"
            name="searchQuery"
            className="form-control"
            value={filter.searchQuery}
            onChange={handleFilterChange}
          />
        </div>

        <div className="col-md-2">
          <label>Estado</label>
          <select
            name="state"
            className="form-select"
            value={filter.state}
            onChange={handleFilterChange}
          >
            <option value="">Todos</option>
            <option value="1">Activo</option>
            <option value="0">Inactivo</option>
          </select>
        </div>

        <div className="col-md-3">
          <label>Fecha inicio</label>
          <input
            type="date"
            name="fechaInicio"
            className="form-control"
            value={filter.fechaInicio}
            onChange={handleFilterChange}
          />
        </div>

        <div className="col-md-3">
          <label>Fecha fin</label>
          <input
            type="date"
            name="fechaFin"
            className="form-control"
            value={filter.fechaFin}
            onChange={handleFilterChange}
          />
        </div>

      </div>

      {/* TABLA */}
      {currentRecords.length > 0 ? (
        <>
          <table className="table table-hover">
            <thead className="table-secondary">
              <tr>
                <th>Número Contrato</th>
                <th>Entidad</th>
                <th>Objeto</th>
                <th>Valor</th>
                <th>Inicio</th>
                <th>Fin</th>
                <th>Estado</th>
                <th>Acciones</th>
                <th>Información contratual</th>
              </tr>
            </thead>

            <tbody>
              {currentRecords.map((c) => (
                <tr key={c.id_contrato}>
                  <td>{c.num_contrato}</td>
                  <td>{c.entidad}</td>
                  <td>{c.objeto}</td>
                  <td>${c.valor_contrato}</td>
                  <td>{formatDate(c.start_date)}</td>
                  <td>{formatDate(c.end_date)}</td>
                  <td>
                    {Number(c.state) === 1 ? "Activo" : "Inactivo"}
                  </td>

                  <td>
                      <div className="d-flex gap-2">
                        <button
                           className="btn btn-outline-purple btn-sm me-2 text-nowrap"
                          onClick={() => handleViewPDF(c.doc_contra_partida)}
                        >
                            <i className="bi bi-eye-fill me-1"></i> Ver PDF
                        </button>

                        <button
                        className="btn btn-secondary btn-sm d-inline-flex align-items-center me-1"
                        onClick={() =>
                        navigate(`/session/mod_proyectos/contrato_proyectos/updateContrato/${c.id_contrato}`)}>
                            <i className="bi bi-pencil-square me-1"></i>
                            <span>Modificar</span>
                        </button>
                      </div>
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-outline-pink btn-sm"
                        onClick={() => handleOpenModal(c)}
                      >
                        <i className="bi bi-folder2-open me-1"></i> Info contractual
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />
        </>
      ) : (
        <p>No hay contratos registrados.</p>
      )}


      {/* MODAL */}
      {showDocModal && selectedContrato && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">
                  Información contractual - {selectedContrato.num_contrato}
                </h5>
                <button className="btn-close" onClick={handleCloseModal}></button>
              </div>

              <div className="modal-body">
                <h6>Documentos</h6>

                  {docError && (
                    <div className="alert alert-danger">{docError}</div>
                  )}

                  <ul className="list-group">
                    {docList.length === 0 && (
                      <li className="list-group-item">Sin documentos</li>
                    )}

                    {docList.map((doc, i) => (
                        <li key={i} className="list-group-item d-flex justify-content-between align-items-center">

                          <div>
                            <strong>{doc.name}</strong>
                          </div>

                          <div className="d-flex gap-2">

                            <a
                              href={`${API_BASE_URL_DOCS}${doc.url}`}
                              target="_blank"
                              rel="noreferrer"
                              className="btn btn-sm btn-outline-pink"
                            >
                              Ver
                            </a>

                            <button
                              className="btn btn-sm btn-secondary"
                              onClick={() => handleDeleteDocument(doc)}
                            >
                              <i className="bi bi-trash3-fill"></i>
                            </button>

                          </div>

                        </li>
                      ))}
                  </ul>
                  <h6 className="mt-3">Agregar documento</h6>

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <select
                        className="form-select"
                        value={newDocType}
                        onChange={(e) => setNewDocType(e.target.value)}
                      >
                        <option value=""hidden>Seleccione tipo...</option>
                        <option value="Contrato">Contrato</option>
                        <option value="Modificacion">Modificación</option>
                        <option value="Poliza">Póliza</option>
                        <option value="Informe">Informe</option>
                      </select>
                    </div>

                    <div className="col-md-6 mb-2">
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) => setNewDocFile(e.target.files[0])}
                      />
                    </div>
                  </div>

                  <button
                    className="btn btn-outline-pink mt-2"
                    onClick={handleUploadDocument}
                    disabled={uploading}
                  >
                    {uploading ? "Subiendo..." : "Subir documento"}
                  </button>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={handleCloseModal}>
                  Cerrar
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Contrato;